import logo from "../../assets/claraViewMedia/LOGO MARK - UNICOLOR.svg"
import QRCode from "qrcode";
import React, { useEffect, useState } from "react";



const QrCode = () => {
    const [qrCode, setQrcode] = useState("");

    useEffect(() => {
        QRCode.toDataURL(window.location.href).then((data) => {
            setQrcode(data);
        });
    }, []);

    return (
        <div className="flex flex-col justify-center items-center h-dvh font-novatica bg-[#F6F6F4]">
            <div className="flex justify-center items-center -mt-10 mb-10">
                <img src={logo} alt="logo" className=" h-16" />
                <p className="text-[#2D3932] text-6xl ms-2 pb-4">claraview</p>
            </div>
            <div className="flex flex-col justify-center items-center  min-h-3/5 h-3/5 min-w-3/5 w-3/5 bg-[#E4E7E5] rounded">
                <p className="font-medium text-xl mb-5">Thank you for visiting!</p>
                <p className="text-sm mb-5  text-center">Claraview works on mobile devices only. Please scan to use the App <br />
                    or type  <span className="font-bold"> {window.location.href} </span> in your mobile browser.</p>
                <img src={qrCode} alt="qrCode" className=" h-64"/>
            </div>
        </div>
    );
};

export default QrCode;